import React from 'react'
import PropTypes from 'prop-types'

const StatusMessage = ({ success, error }) => {
  if (!success && !error) return null

  return (
    <>
      {success && (
        <div className="alert alert-success mb-3" role="status" aria-live="polite">
          <i className="bx bx-check-circle me-1" aria-hidden="true" />{success}
        </div>
      )}
      {error && (
        <div className="alert alert-danger mb-3" role="alert" aria-live="assertive">
          <i className="bx bx-error-circle me-1" aria-hidden="true" />{error}
        </div>
      )}
    </>
  )
}

StatusMessage.propTypes = {
  success: PropTypes.string,
  error: PropTypes.string
}

export default StatusMessage
